(function () {
  'use strict';

  var menuSelector = '[data-panda-temu-menu]';
  var categorySelector = '[data-panda-temu-category]';

  function setActiveCategory(menu, categoryId) {
    var categories = menu.querySelectorAll(categorySelector);
    var panels = menu.querySelectorAll('[data-panda-temu-panel]');

    categories.forEach(function (category) {
      var isActive = category.getAttribute('data-panda-temu-category') === categoryId;

      category.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-panda-temu-panel') === categoryId;
      panel.hidden = !isActive;
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  function categoryFromEventTarget(target) {
    if (!target || !target.closest) {
      return null;
    }

    return target.closest(categorySelector);
  }

  function activateCategory(category) {
    var menu = category.closest(menuSelector);

    if (menu) {
      setActiveCategory(menu, category.getAttribute('data-panda-temu-category'));
    }
  }

  function isActive(category) {
    return category.getAttribute('aria-expanded') === 'true';
  }

  // Mouse: switch only after a short pause, so a diagonal move from a
  // category to its panel does not flip to the categories it crosses.
  var hoverDelay = 150;
  var hoverTimer = null;
  var hoverCategory = null;

  function cancelHover() {
    clearTimeout(hoverTimer);
    hoverTimer = null;
    hoverCategory = null;
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType !== 'mouse') {
      return;
    }

    var category = categoryFromEventTarget(event.target);

    if (category === hoverCategory) {
      return;
    }

    cancelHover();

    if (!category || isActive(category)) {
      return;
    }

    hoverCategory = category;
    hoverTimer = setTimeout(function () {
      activateCategory(category);
      cancelHover();
    }, hoverDelay);
  });

  // Touch/pen: the first tap on an inactive category opens its panel, the
  // second one follows the link. The state is taken at pointerdown, because
  // the focusin that follows already activates the category.
  var tapOpensPanel = false;

  document.addEventListener('pointerdown', function (event) {
    var category = categoryFromEventTarget(event.target);

    tapOpensPanel = Boolean(category) && event.pointerType !== 'mouse' && !isActive(category);
  });

  document.addEventListener('click', function (event) {
    var category = categoryFromEventTarget(event.target);

    if (category && tapOpensPanel) {
      event.preventDefault();
      activateCategory(category);
    }

    tapOpensPanel = false;
  });

  document.addEventListener('focusin', function (event) {
    var category = categoryFromEventTarget(event.target);

    if (category) {
      cancelHover();
      activateCategory(category);
    }
  });

  function initializeMenus(root) {
    var menus = root.querySelectorAll ? root.querySelectorAll(menuSelector) : [];

    menus.forEach(function (menu) {
      var activeCategory = menu.querySelector(categorySelector + '[aria-expanded="true"]') || menu.querySelector(categorySelector);

      if (activeCategory) {
        setActiveCategory(menu, activeCategory.getAttribute('data-panda-temu-category'));
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
      return;
    }

    var category = categoryFromEventTarget(event.target);

    if (!category) {
      return;
    }

    var menu = category.closest(menuSelector);
    var categories = menu ? Array.prototype.slice.call(menu.querySelectorAll(categorySelector)) : [];
    var currentIndex = categories.indexOf(category);
    var nextIndex = event.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;

    if (nextIndex < 0) {
      nextIndex = categories.length - 1;
    }

    if (nextIndex >= categories.length) {
      nextIndex = 0;
    }

    if (categories[nextIndex]) {
      event.preventDefault();
      categories[nextIndex].focus();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeMenus(event.target);
  });

  initializeMenus(document);
}());

(function () {
  'use strict';

  var dropdownSelector = '.site-nav > .site-nav__item--megadropdown > .site-nav__dropdown, .site-nav > .site-nav__item--smalldropdown > .site-nav__dropdown, .site-nav > .site-nav__more-links > .site-nav__dropdown';
  var bottomGap = 24;

  // Caps the open mega dropdown at the space left below the (possibly docked)
  // menu bar, so long menus scroll inside instead of covering the whole screen.
  function fitDropdown(item) {
    var dropdown = item.querySelector(':scope > .site-nav__dropdown');

    if (!dropdown || !dropdown.matches(dropdownSelector)) {
      return;
    }

    var top = Math.max(dropdown.getBoundingClientRect().top, 0);
    var available = Math.max(window.innerHeight - top - bottomGap, 200);

    dropdown.style.setProperty('--panda-mega-menu-available-height', available + 'px');

    // Speech-bubble arrow of the rail menu points at the hovered menu item.
    var itemRect = item.getBoundingClientRect();
    var arrowLeft = itemRect.left + itemRect.width / 2 - dropdown.getBoundingClientRect().left;

    dropdown.style.setProperty('--panda-mega-menu-arrow-left', Math.round(arrowLeft) + 'px');
  }

  var itemSelector = '.site-nav > .site-nav__item--has-dropdown';

  // Measure once when the pointer or focus enters a menu item, not for every
  // link inside its open dropdown.
  function fitFromEvent(event) {
    var item = event.target && event.target.closest ? event.target.closest(itemSelector) : null;

    if (item && !(event.relatedTarget && item.contains(event.relatedTarget))) {
      fitDropdown(item);
    }
  }

  // The sticky header docks on scroll and moves the dropdown, so the open one
  // is measured again.
  var refitPending = false;

  function refitOpenDropdown() {
    if (refitPending) {
      return;
    }

    refitPending = true;
    requestAnimationFrame(function () {
      refitPending = false;

      var item = document.querySelector(itemSelector + '.open');

      if (item) {
        fitDropdown(item);
      }
    });
  }

  document.addEventListener('pointerover', fitFromEvent);
  document.addEventListener('focusin', fitFromEvent);
  window.addEventListener('scroll', refitOpenDropdown, { passive: true });
  window.addEventListener('resize', refitOpenDropdown);
}());
